import { createStore } from "solid-js/store";
import { getLocUserInfo } from "./utils/storage";

/**
 * 用户信息
 */
const [userInfo, setUserInfo] = createStore<any>(getLocUserInfo());

/**
 * 全局分页状态
 */
const [pagination, setPagination] = createStore({
  page: 0,
  size: 20,
});

/**
 * 钱包配置
 */
export const walletOptions = {
  /**
   * 1 系统钱 = ?RMB
   */
  toRmb: "0.01",
};

/**
 * 获取图片读取前缀 URL
 * @returns 图片读取基础 URL
 */
export function getImgReadUrl(): string {
  return import.meta.env.VITE_IMG_READ_URL || "https://imgs.promise.pink/";
}

/**
 * 获取图片上传前缀 URL
 * @returns 图片上传基础 URL
 */
export function getImgUploadUrl(): string {
  return import.meta.env.VITE_IMG_UPLOAD_URL || "https://api-devs.promise.pink/upload/";
}

/**
 * 拼接完整的图片访问 URL
 * @param imgPath 图片路径（相对路径）
 * @returns 完整的图片访问 URL
 */
export function buildImgUrl(imgPath?: string): string {
  if (!imgPath) return "";
  const baseUrl = getImgReadUrl();
  // 确保 baseUrl 以 / 结尾，imgPath 不以 / 开头
  const base = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const path = imgPath.startsWith("/") ? imgPath.substring(1) : imgPath;
  return `${base}${path}`;
}

export { pagination, setPagination, userInfo, setUserInfo };
